module.exports = "/_next/static/images/f27bd5de86d958a55e15bc5a56a8402d-mulher-com-cachos-maravilhosos-segurando-cartao-md@1x.jpg.webp";